// extracted by mini-css-extract-plugin
export default {"box":"root_content-module__box___usR5B","scrollable":"root_content-module__scrollable___hBJM_","mobile":"root_content-module__mobile___kOHK4"};